import React from 'react';
import { Switch } from 'react-router-dom';
import Route from './Route';

import OrdersTable from '~/pages/company/OrdersTable';
import OrderTableDetails from '~/pages/company/OrderTableDetails';

const CompanyRoutes: React.FC = () => {
  return (
    <Switch>
      {/* DASHBOARD */}
      <Route path="/" exact component={OrdersTable} isPrivate />

      <Route path="/table-orders" exact component={OrdersTable} isPrivate />
      <Route path="/table-orders/:id" component={OrderTableDetails} isPrivate />

      <Route path="*" component={OrdersTable} />
    </Switch>
  );
};

export default CompanyRoutes;
